import { CSSProperties } from 'react';
import styles from './Table.module.scss';
import TableCell from './TableCell';
import { stickyColumnStyle, TableData, TableHeader } from './TableDefinitions';
import TableHeaderCell from './TableHeaderCell';

interface ITableColumnProps<T> {
    header: TableHeader<T & { actions?: JSX.Element }>;
    tableData: (TableData & T)[];
    displayDecimalPlaces?: number;
    defaultHeaderOptions?: TableHeader<T & { actions?: JSX.Element }>;
    tableStyle?: 'alternatingRows';
    tallestHeaderHeight: number;
    setTallestHeaderHeight: (tallestHeaderHeight: number) => void;
    includeTotalsRow?: boolean;
    isColumnOrderingEnabled?: boolean;
    hasGroupHeaders?: boolean;
}

// eslint-disable-next-line @typescript-eslint/comma-dangle
const TableColumn = <T,>(props: ITableColumnProps<T>) => {
    const stickyStyles = props.header.pinned && ({ ...stickyColumnStyle, [props.header.pinned]: 0, zIndex: 1 } as CSSProperties);
    const cellWidth = props.header.width ?? props.defaultHeaderOptions?.width;
    const minimumCellWidth = props.header.minimumWidth ?? props.defaultHeaderOptions?.minimumWidth;

    return (
        <div key={String(props.header.field)} style={{ ...stickyStyles, width: cellWidth, minWidth: minimumCellWidth }} className={styles.table_column}>
            <TableHeaderCell
                tableHeader={props.header}
                tallestHeaderHeight={props.tallestHeaderHeight}
                setTallestHeaderHeight={props.setTallestHeaderHeight}
                isColumnOrderingEnabled={props.isColumnOrderingEnabled}
                hasGroupHeaders={props.hasGroupHeaders}
            />
            {props.tableData
                .filter((y) => y.isVisible !== false)
                .map((y, index, array) => (
                    <TableCell
                        // eslint-disable-next-line react/no-array-index-key
                        key={y.rowKey !== undefined ? String(y.rowKey) : index}
                        tableDatum={y}
                        header={props.header}
                        datumIndex={index}
                        displayDecimalPlaces={props.displayDecimalPlaces}
                        tableStyle={props.tableStyle}
                        defaultHeaderOptions={props.defaultHeaderOptions}
                        isTotalsRow={props.includeTotalsRow && index === array.length - 1}
                    />
                ))}
        </div>
    );
};

export default TableColumn;
